import barImg from "../img/designs/bar.png";
import pollosImg from "../img/digitals/pollos-menu.png";
import tacosImg from "../img/digitals/tacos-menu.png";

const digitalMenuData = [
  {
    id: 1,
    link: "https://menu-bar-sample.netlify.app/",
    src: barImg,
    info: "Bar Menu",
    about:
      "Transform your business with our custom digital menus, designed to enhance your customers' dining experience effortlessly.",
    tags: ["web design", "digital menu"],
  },
  {
    id: 2,
    link: "https://pollos-menu-sample.netlify.app/",
    src: pollosImg,
    info: "Bar Menu",
    about:
      "Transform your restaurant with a custom digital menu that showcases your dishes beautifully, more engaging dining experience.",
    tags: ["web design", "digital menu"],
  },
  {
    id: 3,
    link: "https://tacos-digital-menu.netlify.app/",
    src: tacosImg,
    info: "Tacos Menu",
    about:
      "Transform your restaurant with a custom digital menu that showcases your dishes beautifully, more engaging dining experience.",
    tags: ["web design", "digital menu"],
  },
];

export default digitalMenuData;
